module.exports = __webpack_public_path__ + "Flaticon.55a36b7297c39fe6e15c.svg";


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/assets/font/Flaticon.svg
// module id = ../../../../../src/assets/font/Flaticon.svg
// module chunks = styles